import { render } from "./province-update.vue?vue&type=template&id=6829a28e"
import script from "./province-update.vue?vue&type=script&lang=js"
export * from "./province-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__